import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './disclaimer.module.scss';

export default function Disclaimer({
  tc = '',
  footNotes = [],
  disclaimerDynamicFooter = '',
  disclaimerGlobalFooter = '',
}) {
  return (
    <div className={styles.disclaimer}>
      <div className={styles.disclaimerContainer}>
        {tc && <div className={styles.tc}>{parse(`${tc}`)}</div>}
        {footNotes && (
          <div className={styles.footnotes}>
            <ol className={styles.ol}>
              {footNotes?.map((footnote, index) => (
                <li
                  className={styles.disclaimerList}
                  data-footnote-item={index}
                  key={`fn-${index}`.toString()}
                >
                  {parse(`${footnote}`)}
                </li>
              ))}
            </ol>
          </div>
        )}
        {disclaimerDynamicFooter && (
          <div className={styles.disclaimerDynamicFooter}>
            {parse(`${disclaimerDynamicFooter}`)}
          </div>
        )}
        {disclaimerGlobalFooter && (
          <div className={styles.disclaimerGlobalFooter}>
            {parse(`${disclaimerGlobalFooter}`)}
          </div>
        )}
      </div>
    </div>
  );
}

Disclaimer.propTypes = {
  tc: PropTypes.string,
  footNotes: PropTypes.array,
  disclaimerDynamicFooter: PropTypes.string,
  disclaimerGlobalFooter: PropTypes.string,
};
